import script from "./IAdditionalsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IAdditionalsModal.vue?vue&type=script&setup=true&lang=js"

import "./IAdditionalsModal.vue?vue&type=style&index=0&id=09a0709c&scoped=true&lang=scss"
import "./IAdditionalsModal.vue?vue&type=style&index=1&id=09a0709c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a0709c"]])

export default __exports__